<template>
	<form @submit.prevent="startSubmit($event)">
		<smart-input
			v-model="form.name"
			required
			:error="inputErrors.name"
			:label="$t('pages.mygames.gameName')"
		/>
		<v-select
			v-model="form.company_id"
			v-can="['admin', 'manager']"
			v-if="isAdmin || isManager"
			:items="companies"
			item-text="name"
			item-value="id"
			label="מרכז"
		/>
		<v-select
			v-model="form.type_id"
			:required="true"
			:error-messages="inputErrors.type_id"
			:items="types"
			item-text="name"
			item-value="id"
			:label="$t('pages.mygames.gameType')"
			:disabled="!isNew || hasRouteParamsTypeId"
		/>

		<p>
			{{
				type.description && Object.values(type.description).length > 0
					? type.description
					: ""
			}}
		</p>

		<media-gallery-preview v-model="form.media_id" :image-url="game.logo" />

		<tags-select v-model="form.newTags" :initial-tags="form.tags" />
		<v-switch
			v-if="organization.can_share"
			v-model="form.share"
			:error="inputErrors.public"
			:label="$t('pages.createGame.displayOut')"
			class="mx-2"
		/>
		<v-switch
			v-if="isManager"
			v-model="form.public"
			:error="inputErrors.public"
			:label="$t('pages.createGame.forAll')"
			class="mx-2"
		/>

		<v-expansion-panels v-if="false">
			<v-expansion-panel>
				<v-expansion-panel-header>
					{{ $t("pages.createQuestion.advanced") }}
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<smart-input
						v-model="form.f_pixel"
						:error="inputErrors.f_pixel"
						:hint="$t('pages.createGame.warmingTouch')"
						label="Facebook Pixel"
						name="f_pixel"
					/>
					<smart-input
						v-model="form.google_tag"
						:error="inputErrors.google_tag"
						:hint="$t('pages.createGame.warmingTouch')"
						label="Google Tag"
						name="google_tag"
					/>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<div class="form-group mt-5">
			<v-btn type="submit" color="success">
				{{ $t("generics.save") }}
			</v-btn>
		</div>
	</form>
</template>

<script>
import GameModule from "src/store/modules/Game.module";
import FormView from "src/mixins/FormView";
import { types as TypesTypes } from "src/store/modules/Type.module";
import TagsSelect from "root/packages/closeapp/QuestionsManager/assets/views/questions/TagsSelect.vue";
import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";

export default {
	name: "GameForm",
	components: { MediaGalleryPreview, TagsSelect },
	props: [],
	data() {
		return {
			form: {
				name: "",
				share: true
			}
		};
	},
	mixins: [new FormView(GameModule, "game")],
	computed: {
		isNew() {
			return !(this.game && this.game.id);
		},
		companies() {
			return this.$store.state.CompanyModule.companies;
		},
		types() {
			return this.$store.state.TypeModule.types.filter(type => type.active);
		},
		type() {
			return this.$store.state.TypeModule.type;
		},
		isManager() {
			return this.$store.getters.isManager;
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		organization() {
			return this.$store.state.CurrentOrg.organization;
		},

		hasRouteParamsTypeId(){
			return !!this.$route.params && !!this.$route.params.typeId;
		}
	},
	watch: {
		"form.newTags": {
			handler() {
				if (this.game.tags && this.game.tags.length > 0) {
					this.form.tags.concat(this.game.tags);
				}
			},
			immediate: true
		}
	},

	async created() {
		await this.$store.dispatch(TypesTypes.FETCH);
		if (this.$route.params.typeId) {
			this.form.type_id = this.$route.params.typeId;
		} else if (! this.isNew) {
			this.form.type_id = this.game.type_id;
		} else {
			this.form.type_id = "";
		}
		// this.form.type_id = this.$route.params.typeId || "";
	},
	methods: {
		startSubmit(e) {
			// ! important = FormView.js should be modified so that data sent to server could be changed without modifying this.form
			// ! in case request fails etc.
			// if (this.form.newTags && this.form.newTags.length > 0) {
			// 	this.form.newTags = this.form.newTags.filter(val => !this.form.tags.includes(val));
			// }
			this.onSubmit(e);
		},
		onReset() {
			this.$emit("clear-errors");
		}
	}
};
</script>

<style></style>
